import { Box, Button, IconButton, Typography } from "@mui/material";
import React from "react";
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
const OneRow = ({ index, sub, subNum, seekToVideo }) => {
  return (
    <Box
      style={{
        display: "flex",
        borderTop: "solid",
        justifyContent: subNum == "two" ? "end" : "space-between",
        mx: 1,
        my: "auto",
      }}
    >
      <Typography sx={{ textAlign: subNum == "two" ? "left" : "right" }}>
        {sub["text"]}
      </Typography>

      <Typography
        sx={{ cursor: "pointer" }}
        onClick={() => {
          seekToVideo(sub["startSeconds"]);
        }}
      >
        <PlayCircleIcon />
      </Typography>
    </Box>
  );
};
export default OneRow;
